/* import __COLOCATED_TEMPLATE__ from './upgrade-install-banner.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';

export default class UpgradeInstallBanner extends Component {
  get upgradeMessageKey() {
    return 'outbound.tooltips.paywall-banner.upgrade';
  }
}
